import axios from "axios";

const state = {
  league: null,
};

const getters = {
  league(state) { return state.league },
};

const actions = {
  getLeague({ commit }) {
    axios.get(process.env.VUE_APP_API_URL + 'league/league')
      .then(response => {
        commit('SET_LEAGUE', response.data.data.league);
      })
  }
};

const mutations = {
  SET_LEAGUE(state, data) { state.league = data }
};


export default {
  state,
  getters,
  actions,
  mutations,
}
